/*
 * @Author: Qzx
 * @Date: 2019-06-17 17:17:33
 * @Description: 常用基础函数
 * @LastEditors: Qzx
 * @LastEditTime: 2019-12-02 19:25:32
 */
/**
 * 获取url参数的值
 * @param {*} url 通常为window.location.href
 * @return {Object} params  参数数组
 */
function getUrlParmas(url) {
    let vars = {};
    url.replace(/[?&]+([^=&]+)=([^&#]*)/gi, function (m, key, value) {
        vars[key] = value;
    });
    return vars;
}
/**
 * 获取热点投放链接里面的参数 hot_url
 * @param {string} hotUrl  热点url
 */
function getHotUrl(hotUrl) {
    let _hotUrlParmas = {};
    if (hotUrl) {
        _hotUrlParmas = getUrlParmas(window.atob(window.unescape(hotUrl))) || {};
    }
    return _hotUrlParmas;
}

/*
 * @Author: yzx
 * @Description: 投放项目各渠道统计代码
 * @Date: 2019-02-27 14:30:55
 * @LastEditors: Qzx
 * @LastEditTime: 2020-04-08 16:51:45
 */
class XesChannel {
    constructor() {
        this.urlParmas = getUrlParmas(window.location.href); // url参数
        this.urlParams = getUrlParmas(window.location.href); // url参数
        this.hotUrlParams = getHotUrl(this.urlParams.hot_url); // 热点url参数
        this.channel = this.urlParams.channel || ''; // 投放渠道值, 投放渠道 百度、头条、UC等
        this.countid = this.urlParams.countid || ''; // 日志统计id 唯一，账户区分
        this.accountid = this.urlParams.accountid || ''; // 额外上报参数
        this.buyid = this.urlParams.buyid || ''; // 购课回传额外上报参数
        this.init();
    }
    init() {
        // 根据各渠道，执行页面曝光脚本，用于统计 PV、UV
        switch (this.channel) {
            case '1': // toutiao
                this.initToutiaoScript();
                break;
            case '2': // uc浏览
                this.initUcScript();
                break;
            case '3': // 百度
                this.initBaiduScript();
                break;
            case '4': // weibo
                this.initWeiboScript();
                break;
            case '5': // 快手
                this.initkuaishouScript();
                break;
            case '6': // 百度原生(已废弃)
                this.initBaiduJiantingScript();
                break;
            case '7': // 搜狐
                this.initSohuScript();
                break;
            case '8': // 凤凰 - 凤羽客户平台ifeng
                this.initFenghuangScript();
                break;
            case '9': // 喜马拉雅
                this.initHimalayaScript();
                break;
            case '10': // 小度音箱 - 推啊
                this.initTuisnakeScript();
                break;
            case '11': // google-转化回传
                this.initGoogleScript();
                break;
            default:
                console.log('无相关投放渠道');
        }
    }
    /**
     * 新用户注册成功发送统计日志，用于统计有效注册量
     */
    regSuccess() {
        switch (this.channel) {
            case '1': // toutiao
                window.meteor && window.meteor.track('form', { convert_id: this.countid });
                break;
            case '2': // uc
                window.utq && window.utq('track', 'FormSubmit', this.countid);
                break;
            case '3': // 百度
                window._agl && window._agl.push(['track', ['success', { t: this.countid }]]);
                break;
            case '4': // 微博
                window.wbadmt && window.wbadmt.send({
                    eventid: this.countid,
                    eventtype: 'form',
                    eventvalue: ''
                });
                break;
            case '5': // 快手
                window._ks_trace && window._ks_trace.push({ event: 'click3', cb: function () { } });
                break;
            case '7': // 搜狐
                window._shTrackSendLog && window._shTrackSendLog({ 'trackId': "12", 'trackType': "FORM", 'convertId': this.countid });
                break;
            case '9': // 喜马拉雅
                window.xmlyAdLog && window.xmlyAdLog.track(1, { key: this.countid });
                break;
            default:
                console.log('无相关投放渠道注册回传');
        }
    }
    /**
     * 购课成功发送统计日志，用于统计有效购买量
     */
    buySuccess() {
        switch (this.channel) {
            case '4': // 微博
                window.wbadmt && window.wbadmt.send({
                    eventid: this.buyid,
                    eventtype: 'shopping',
                    eventvalue: ''
                });
                break;
            // case '7': // 搜狐
            //   window._shTrackSendLog && window._shTrackSendLog({ 'trackId': "19", 'trackType': "PURCHASE", 'convertId': this.buyid })
            //   break
            case '8': // 凤凰 - 凤羽客户平台ifeng
                window.ifMgrOcpc && window.ifMgrOcpc.conver("http://api.feather.ifeng.com/otherApi/ocpc/order?convertId=" + this.countid + "&args=", this.buyid);
                break;
            case '10': // 小度音箱 - 推啊
                if (window.countLog) {
                    window.countLog.ready(function () {
                        window.countLog.init(function () { }, {
                            isCopy: 0,
                            pageType: 3 // 上报转化类型， 3 下单
                        });
                    });
                }
                break;
            case '11': // google回传
                window.gtag('event', 'conversion', { 'send_to': 'AW-629581550/29m_CL290NEBEO7NmqwC', 'transaction_id': '' });
                break;
            default:
                console.log('无相关投放渠道购课回传');
        }
    }
    /**
     * 谷歌转化购课成功回传脚本
     */
    initGoogleScript() {
        (function () {
            let script = document.createElement('script');
            script.src = 'https://www.googletagmanager.com/gtag/js?id=AW-629581550';
            script.type = "text/javascript";
            document.getElementsByTagName('head')[0].appendChild(script);
            script.onload = function () {
                window.dataLayer = window.dataLayer || [];
                window.gtag = function () {
                    window.dataLayer.push(arguments);
                };
                window.gtag('js', new Date());
                window.gtag('config', 'AW-629581550');
            };
        })();
    }
    /**
     * 注入小度音箱 - 推啊统计脚本
     */
    initTuisnakeScript() {
        (function () {
            let script = document.createElement('script');
            script.src = '//yun.tuisnake.com/h5-mami/log_seed.js';
            script.id = 'send_log';
            let s = document.getElementsByTagName('script')[0];
            s.parentNode.insertBefore(script, s);
        })();
    }
    /**
     * 注入喜马拉雅统计脚本
     */
    initHimalayaScript() {
        (function (win, doc, src, version) {
            let sc = doc.createElement('script');
            sc.type = "text/javascript";
            sc.src = src + '?v=' + version;
            win.XMLY_ADOCPC_APPKEY = '7b912d1749bf641a6f73471a44574aa8';
            let s = document.getElementsByTagName('script')[0];
            s.parentNode.insertBefore(sc, s);
        })(window, document, '//s1.xmcdn.com/yx/ad-jssdk-static/last/dist/app.min.js', new Date().getTime());
    }
    /**
     * 注入凤凰 - 凤羽客户平台统计脚本
     */
    initFenghuangScript() {
        (function () {
            let script = document.createElement('script');
            script.src = '//c0.ifengimg.com/ocpc/op.js';
            let s = document.getElementsByTagName('script')[0];
            s.parentNode.insertBefore(script, s);
        })();
    }
    /**
     * 注入搜狐页面曝光统计脚本
     */
    initSohuScript() {
        (function (root) {
            let script = document.createElement('script');
            script.type = 'text/javascript';
            script.async = true;
            script.src = '//fdf24fb6ce298.cdn.sohucs.com/track-report/adTackRport.js';
            script.onerror = function () { };
            let s = document.getElementsByTagName('script')[0];
            s.parentNode.insertBefore(script, s);
        })();
    }
    /**
     * 注入头条页面曝光统计脚本
     */
    initToutiaoScript() {
        (function (r, d, s, l) {
            let meteor = (r.meteor = r.meteor || []);
            meteor.methods = ['track', 'off', 'on'];
            meteor.factory = function (method) {
                return function () {
                    let args = Array.prototype.slice.call(arguments);
                    args.unshift(method);
                    meteor.push(args);
                    return meteor;
                };
            };
            for (let i = 0; i < meteor.methods.length; i++) {
                let key = meteor.methods[i];
                meteor[key] = meteor.factory(key);
            }
            meteor.load = function () {
                let js;
                let fjs = d.getElementsByTagName(s)[0];
                js = d.createElement(s);
                js.src = 'https://analytics.snssdk.com/meteor.js/v1/' + l + '/sdk';
                fjs.parentNode.insertBefore(js, fjs);
            };
            meteor.load();
            if (meteor.invoked) {
                return;
            }
            meteor.invoked = true;
            meteor.track('pageview');
        })(window, document, 'script', window._wltfChannel.accountid);
    }
    /**
     * 注入头uc页面曝光统计脚本
     */
    initUcScript() {
        (function (w, d, t, s, q, m, n) {
            if (w.utq)
                return;
            w.utq = function () {
                q.process ? q.process(arguments) : q.queue.push(arguments);
            };
            q = w.utq;
            q.queue = [];
            m = d.getElementsByTagName(t)[0];
            n = d.createElement(t);
            n.src = s;
            n.async = true;
            m.parentNode.insertBefore(n, m);
        })(window, document, 'script', 'https://image.uc.cn/s/uae/g/0s/ad/utracking.js');
        {
            window.utq('set', 'convertMode', true);
        }
        {
            window.utq('set', 'trackurl', 'huichuan.sm.cn/lp');
        }
    }
    /**
     * 注入百度页面曝光统计脚本
     */
    initBaiduScript() {
        window._agl = window._agl || [];
        window._agl.push(['production', '_f7L2XwGXjyszb4d1e2oxPybgD']);
        (function () {
            let agl = document.createElement('script');
            agl.type = 'text/javascript';
            agl.async = true;
            agl.src = 'https://fxgate.baidu.com/angelia/fcagl.js?production=_f7L2XwGXjyszb4d1e2oxPybgD';
            let s = document.getElementsByTagName('script')[0];
            s.parentNode.insertBefore(agl, s);
        })();
    }
    /**
     * 注入百度原生统计脚本
     */
    initBaiduJiantingScript() {
        window._hmt = window._hmt || [];
        (function () {
            var hm = document.createElement("script");
            hm.src = "https://hm.baidu.com/hm.js?86491d9a1754f798fcbb1f75f13848a0";
            var s = document.getElementsByTagName("script")[0];
            s.parentNode.insertBefore(hm, s);
        })();
    }
    /**
     * 注入微博页面曝光统计脚本
     */
    initWeiboScript() {
        (function (root) {
            let script = document.createElement('script');
            script.type = 'text/javascript';
            script.crossOrigin = 'anonymous';
            script.src = '//cheka.biz.weibo.com/index';
            script.onerror = function () {
                let request = new XMLHttpRequest();
                let web_url = window.encodeURIComponent(window.location.href);
                let url = '//cheka.biz.weibo.com/v1/error';
                let data = {
                    error: {
                        url: web_url,
                        message: '404',
                        name: '__SDK_CDN__',
                        detail: {}
                    }
                };
                request.open('POST', url, true);
                request.send('param=' + encodeURIComponent(data));
            };
            let s = document.getElementsByTagName('script')[0];
            s.parentNode.insertBefore(script, s);
        })();
    }
    /**
     * 注入快手脚本页面曝光统计脚本
     */
    initkuaishouScript() {
        (function (root) {
            let ksscript = document.createElement('script');
            ksscript.type = 'text/javascript';
            ksscript.async = true;
            ksscript.src = 'https://static.yximgs.com/udata/pkg/ks-ad-trace-sdk/ks-trace.0.0.8.beta.js';
            ksscript.onerror = function () {
                let request = new XMLHttpRequest();
                let cb = (function (t) {
                    let e = new RegExp('(^|&)' + t + '=([^&|#]*)(&|#|$)');
                    let n = window.location.href.indexOf('?') > -1
                        ? window.location.href.split('?')[1].match(e)
                        : null;
                    return n != null ? decodeURIComponent(n[2]) : null;
                })('callback');
                let url = 'https://e.kuaishou.com/rest/log/activate?jsEventType=3&callback=' +
                    cb +
                    '&eventType=4&eventTime=' +
                    Date.now();
                request.open('GET', url, true);
                request.send(null);
            };
            let s = document.getElementsByTagName('script')[0];
            s.parentNode.insertBefore(ksscript, s);
        })();
    }
}

export default XesChannel;
